import { v4 as uuidv4 } from 'uuid';

export class GuidService {
  static generateNew(): string {
    return uuidv4();
  }
}
